import { star } from 'cli-spinners'

export function collides(allEntries, entry, ignoreTeams = true) {
  for (const tempEntry of allEntries) {
    if (tempEntry.id !== entry.id && (ignoreTeams || tempEntry.teamId === entry.teamId) && !tempEntry.isDeleted) {
      if (tempEntry.start < entry.end && tempEntry.end > entry.start) {
        return true
      }
    }
  }

  return false
}

export function isSticked(allEntries, entry, ignoreTeams = true) {
  for (const tempEntry of allEntries) {
    if (tempEntry.id !== entry.id && (ignoreTeams || tempEntry.teamId === entry.teamId) && !tempEntry.isDeleted) {
      if (tempEntry.start == entry.end || tempEntry.end == entry.start) {
        return true
      }
    }
  }
  return false
}

export function getBestFittingPlaceEntry(allEntries, entry, isSticked, acceptableThresholdMinutes, ignoreTeams = true) {
  let bestCandidate = { ...entry }
  let bestCandidateOverlapp = Number.MAX_SAFE_INTEGER
  let candidate = { ...entry }
  let acceptableThresholdMS = acceptableThresholdMinutes * 60 * 1000

  if (isSticked) {
    for (const tempEntry of allEntries) {
      if (tempEntry.id !== entry.id && (ignoreTeams || tempEntry.teamId === entry.teamId) && !tempEntry.isDeleted) {
        if (tempEntry.start < entry.end && tempEntry.end > entry.start) {
          // if overlapping then check if acceptable treshold but only if not sticked
          // check all entries to find best matching spot
          let diff1 = entry.end.getTime() - tempEntry.start.getTime()
          let diff2 = tempEntry.end.getTime() - entry.start.getTime()
          let diffMin = Math.min(diff1, diff2)
          if (diffMin < bestCandidateOverlapp) {
            if (diffMin < acceptableThresholdMS) {
              if (diff1 == diffMin) {
                candidate.start = new Date(entry.start.getTime() - diff1)
                candidate.end = new Date(entry.end.getTime() - diff1)
              } else {
                candidate.start = new Date(entry.start.getTime() + diff2)
                candidate.end = new Date(entry.end.getTime() + diff2)
              }

              if (!collides(allEntries, candidate, ignoreTeams)) {
                bestCandidateOverlapp = diffMin
                bestCandidate.start = candidate.start
                bestCandidate.end = candidate.end
              }
            }
          }
        }
      }
    }
  } else {
    // simply find nearest spot
    for (const tempEntry of allEntries) {
      if (tempEntry.id !== entry.id && (ignoreTeams || tempEntry.teamId === entry.teamId) && !tempEntry.isDeleted) {
        if (tempEntry.start < entry.end && tempEntry.end > entry.start) {
          // if overlapping then check if acceptable treshold but only if not sticked
          // check all entries to find best matching spot
          let diff1 = entry.end.getTime() - tempEntry.start.getTime()
          let diff2 = tempEntry.end.getTime() - entry.start.getTime()
          if (diff1 < bestCandidateOverlapp) {
            candidate.start = new Date(entry.start.getTime() - diff1)
            candidate.end = new Date(entry.end.getTime() - diff1)
            if (!collides(allEntries, candidate, ignoreTeams)) {
              bestCandidateOverlapp = diff1
              bestCandidate.start = candidate.start
              bestCandidate.end = candidate.end
            }
          }
          if (diff2 < bestCandidateOverlapp) {
            candidate.start = new Date(entry.start.getTime() + diff2)
            candidate.end = new Date(entry.end.getTime() + diff2)
            if (!collides(allEntries, candidate, ignoreTeams)) {
              bestCandidateOverlapp = diff2
              bestCandidate.start = candidate.start
              bestCandidate.end = candidate.end
            }
          }
        }
      }
    }
  }
  if (bestCandidateOverlapp != Number.MAX_SAFE_INTEGER) {
    return bestCandidate
  } else {
    return null
  }
}

export function maxPossibleEntryFromStartPoint(allEntries, start, maxDuration, teamId, ignoreTeams = true) {
  let maxDurationMS = maxDuration * 60 * 1000
  let bestCandidate = new Date(start.getTime() + maxDurationMS)

  for (const tempEntry of allEntries) {
    if (!tempEntry.isDeleted) {
      if (ignoreTeams || tempEntry.teamId === teamId) {
        if (tempEntry.start <= start && tempEntry.end > start) {
          return null /* if there is any entry crossing start then not possible to create */
        } else {
          if (tempEntry.start > start && tempEntry.start < bestCandidate) {
            bestCandidate = tempEntry.start
          }
        }
      }
    }
  }
  return bestCandidate
}

/* we assume that entry collides with entries */
export function resizingDownEntryBestFittingEnd(allEntries, entry, acceptableThresholdMinutes, teamId, ignoreTeams = true) {
  let acceptableThresholdMS = acceptableThresholdMinutes * 60 * 1000
  let start = entry.start
  let bestCandidate = { ...entry }

  for (const tempEntry of allEntries) {
    if (!tempEntry.isDeleted && tempEntry.id !== entry.id) {
      if (ignoreTeams || tempEntry.teamId === teamId) {
        if (tempEntry.start < start && tempEntry.end > start) {
          return null /* if there is any entry crossing start then not possible to create */
        } else {
          if (tempEntry.start > start && tempEntry.start < bestCandidate.end) {
            // let dd = new Date(tempEntry.start.getTime() - diff1)
            bestCandidate.end = tempEntry.start
          }
        }
      }
    }
  }

  return bestCandidate
}

/* we assume that entry collides with entries */
export function resizingUpEntryBestFittingStart(allEntries, entry, acceptableThresholdMinutes, teamId, ignoreTeams = true) {
  let acceptableThresholdMS = acceptableThresholdMinutes * 60 * 1000
  let end = entry.end
  let bestCandidate = { ...entry }

  for (const tempEntry of allEntries) {
    if (!tempEntry.isDeleted && tempEntry.id !== entry.id) {
      if (ignoreTeams || tempEntry.teamId === teamId) {
        if (tempEntry.start < end && tempEntry.end > end) {
          return null /* if there is any entry crossing start then not possible to create */
        } else {
          if (tempEntry.end < end && tempEntry.end > bestCandidate.start) {
            bestCandidate.start = tempEntry.end
          }
        }
      }
    }
  }
  return bestCandidate
}
